module.exports = __webpack_public_path__ + "img/service2.4b0e4a6b.png";